import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BranchCreateEditModalComponent } from './branch-create-edit-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    BranchCreateEditModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbTooltipModule,
    NgbModalModule,
  ],
  exports: [BranchCreateEditModalComponent],
  providers: []
})
export class BranchCreateEditModalModule { }
